import { PLACE_LKPS_LOADED, PLACE_LKPS_FAILED, PLACE_LKPS_LOADING } from './actionTypes';

const INITIAL_STATE = {
    countries: [],
    entities: [],
    cantons: [],
    municipalities: [],
    defaults: {},
    loading: false,
    error: false,
    loaded: false,
};


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case PLACE_LKPS_LOADED:
        return {
            ...state,
            countries: action.payload.countries,
            cantons: action.payload.cantons,
            entities: action.payload.entities,
            municipalities: action.payload.municipalities,
            defaults: action.payload.defaults,
            loaded: true,
            error: false,
            loading: false
        };
    case PLACE_LKPS_LOADING:
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    case PLACE_LKPS_FAILED:
        return {
            ...INITIAL_STATE,
            error: true,
            loading: false,
            loaded: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reduxFiles/placeReducer.js